/**
 * Format a dollar amount for display.
 *
 * Shows no decimals when the amount is a whole dollar and exactly two
 * decimals when there are cents — so $2,067 stays "$2,067" while $2,067.4
 * renders as "$2,067.40" (never a lone "$2,067.4").
 *
 * Use this for all displayed money in the app instead of `toLocaleString()`
 * or hand-rolled `$${amount}` interpolation, which don't pad cents.
 */
export const formatCurrency = (amount: number): string => {
  // Guard against floating-point noise (e.g. 2067.4000000001) before
  // deciding whether there are cents.
  const hasCents = Math.round(amount * 100) % 100 !== 0;
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: hasCents ? 2 : 0,
    maximumFractionDigits: 2,
  }).format(amount);
};
